
import { Options, Vue } from 'vue-class-component'

@Options({
	name: 'BFooter',
})
export default class extends Vue {}
